var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHornActiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.71875,8c-0.7841797,0-1.5195312,0.4121094-1.9199219,1.0766602C39.5732422,12.7827148,34.4316406,19,25,19h-7v-4 c0-1.6542969-1.3457031-3-3-3H5c-1.6542969,0-3,1.3457031-3,3v18c0,1.6542969,1.3457031,3,3,3h10c1.6542969,0,3-1.3457031,3-3v-4h7 c9.4316406,0,14.5732422,6.2172852,16.7998047,9.9238281C42.1992188,39.5878906,42.9345703,40,43.7441406,40 C44.9882812,40,46,38.9897461,46,37.7480469V24V10.2519531C46,9.0102539,44.9882812,8,43.71875,8z M16,33 c0,0.5512695-0.4482422,1-1,1H5c-0.5517578,0-1-0.4487305-1-1V15c0-0.5512695,0.4482422-1,1-1h10c0.5517578,0,1,0.4487305,1,1V33z  M44,37.7480469c0,0.2124023-0.3720703,0.3369141-0.4863281,0.1455078C41.0703125,33.8251953,35.4169922,27,25,27h-7v-6h7 c10.4169922,0,16.0703125-6.8251953,18.5126953-10.8925781C43.6025391,9.9575195,44,10.0014648,44,10.2519531V24V37.7480469z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHornActiveMedium);
export default __webpack_public_path__ + "static/media/horn-active--medium.95c52bfae60e8ac79800ba1023b5394d.svg";
export { ForwardRef as ReactComponent };